/**
*
* ConsentChannelGroup
*
*/

import React from 'react';
import ConsentChannel from 'components/ConsentChannel';
import PropTypes from 'prop-types';
import {
  ERROR_TEXT_NO_SELECTED_CHANNEL,
} from 'langs/en/errors';
import { INVALID_COMPONENT_CLASS } from 'utils/constants';

class ConsentChannelGroup extends React.Component {

  validateAndChangeAtLeastOneCheckboxChecked = (keyPath, value) => {
    const previousNumberChecked = Object.keys(this.props.formSubState).filter((key) => this.props.formSubState[key].include).length;
    this.props.onFieldValueChange(keyPath, value);
    if (previousNumberChecked === 0 && value) {
      this.props.onFieldValidityChange(this.props.keyPath, true);
    } else if (previousNumberChecked === 1 && !value) {
      this.props.onFieldValidityChange(this.props.keyPath, false, ERROR_TEXT_NO_SELECTED_CHANNEL);
    }
  }

  render() {
    const {
      formSubState,
      uiSubState,
      keyPath,
      onFieldValidityChange,
      onFieldUIStateChange,
      onFieldValueChange,
    } = this.props;
    const markGroupInvalid = uiSubState.isValid === false;

    return (
      <div className={`mb-2 ${markGroupInvalid ? INVALID_COMPONENT_CLASS : ''}`}>
        <ConsentChannel
          channelName="Email"
          keyPath={[...keyPath, 'email']}
          formSubState={formSubState.email}
          uiSubState={uiSubState.email}
          onCheckboxChange={this.validateAndChangeAtLeastOneCheckboxChecked}
          onFieldValidityChange={onFieldValidityChange}
          onFieldValueChange={onFieldValueChange}
          onFieldUIStateChange={onFieldUIStateChange}
        />
        <ConsentChannel
          channelName="Phone"
          keyPath={[...keyPath, 'phone']}
          formSubState={formSubState.phone}
          uiSubState={uiSubState.phone}
          onCheckboxChange={this.validateAndChangeAtLeastOneCheckboxChecked}
          onFieldValidityChange={onFieldValidityChange}
          onFieldValueChange={onFieldValueChange}
          onFieldUIStateChange={onFieldUIStateChange}
        />
        <ConsentChannel
          channelName="SMS"
          keyPath={[...keyPath, 'sms']}
          formSubState={formSubState.sms}
          uiSubState={uiSubState.sms}
          onCheckboxChange={this.validateAndChangeAtLeastOneCheckboxChecked}
          onFieldValidityChange={onFieldValidityChange}
          onFieldValueChange={onFieldValueChange}
          onFieldUIStateChange={onFieldUIStateChange}
        />
        {markGroupInvalid ? <span className="invalid-feedback" style={{ display: 'block' }}>{uiSubState.errorDisplay}</span> : null}
      </div>
    );
  }
}

ConsentChannelGroup.propTypes = {
  keyPath: PropTypes.array.isRequired,
  formSubState: PropTypes.shape({
    email: PropTypes.shape({
      include: PropTypes.bool,
      text: PropTypes.string,
    }),
    phone: PropTypes.shape({
      include: PropTypes.bool,
      text: PropTypes.string,
    }),
    sms: PropTypes.shape({
      include: PropTypes.bool,
      text: PropTypes.string,
    }),
  }).isRequired,
  uiSubState: PropTypes.object.isRequired,
  onFieldValidityChange: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
};

export default ConsentChannelGroup;
